import { call, put } from 'redux-saga/effects'
// import { baseFetchToken } from './BaseSaga'
import DbActions from '../Redux/DbRedux'
import AuthActions from '../Redux/AuthRedux'
import { getToken } from '../Services/GetToken'

export function * dbDump (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.dumpDatabase, token)
      if (!res.ok) {
        yield put(DbActions.dbDumpFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          yield put(DbActions.dbDumpSuccess())
        } else {
          yield put(DbActions.dbDumpFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(DbActions.dbDumpFailure())
  }
}



// WEBPACK FOOTER //
// ./src/Sagas/DbSagas.js